// playground requires you to assign document definition to a variable called dd
// playground requires you to assign document definition to a variable called dd
export const convertToPDFProducts = (items,isGST) => {
	let productList = [];
	let totalObj = {
		quantity: 0,
		basicPrice: 0,
		totlePrice: 0,
	}
	items.map((item, index) => {
		let product = [];
		product.push({ text: index + 1, style: "product1" });
		product.push({ text: item.productName + (item.subDescription ? "( "+item.subDescription+ " )" : ""), style: "product1" });
		// if(isGST) {
		// product.push({ text: item.HSN_code, style: "product1" });
		// }
		product.push({ text: item.quantity, style: "productRight" });
		product.push({ text: item.unit, style: "product1" });
		product.push({ text: '₹ ' + item.rate, style: "productRight" });
	
		product.push({ text: '₹ ' + item.basicPrice, style: "productRight" });
		totalObj.quantity += item.quantity;
		totalObj.basicPrice += Number.parseFloat(item.basicPrice);
		if(isGST) {
			product.push({ text: '₹ ' + item.totlePrice, style: "productRight" });
			totalObj.totlePrice += Number.parseFloat(item.totlePrice);
		}
		productList.push(product);
	})
    
	if(isGST) {
		productList.push([
			{ text: '', style: "product" },
			{ text: 'Total', style: "productTotalLeft" },
			// { text: '', style: "product" },
			{ text: totalObj.quantity, style: "productTotalRight" },
			{ text: '', style: "product" },
			{ text: '', style: "product" },
			{ text: totalObj.basicPrice.toFixed(2), style: "productTotalRight" },
			{ text: totalObj.totlePrice.toFixed(2), style: "productTotalRight" }
		]);
	} else {
		productList.push([
			{ text: '', style: "product" },
			{ text: 'Total', style: "productTotalLeft" },
			// { text: '', style: "product" },
			{ text: totalObj.quantity, style: "productTotalRight" },
			{ text: '', style: "product" },
			{ text: '', style: "product" },
			{ text: totalObj.basicPrice.toFixed(2), style: "productTotalRight" }
		]);
	}
    return productList;
}


const getBase64ImageFromURL = async (url)=> {
	    return new Promise((resolve, reject) => {
		var img = new Image();
		img.setAttribute("crossOrigin", "anonymous");
	
		img.onload = () => {
			var canvas = document.createElement("canvas");
			canvas.width = img.width;
			canvas.height = img.height;
	
			var ctx = canvas.getContext("2d");
			ctx.drawImage(img, 0, 0);
	
			var dataURL = canvas.toDataURL("image/png");
	
			resolve(dataURL);
		};
	
		img.onerror = error => {
			reject(error);
		};
	
		img.src = url;
	});
}


export const convertToOrder = async (metaData)=>{
	let pdfDoc =    {
		content: [
			{
				table: {
					widths: ['40%','60%'],
					body: [
						[
							{
								image: 'sampleImage.jpg',
								width: 120,
								height: 80,
								},
  
								{
								text:
									[
										{ text: 'Firm Name\n', style: 'FirmHeader' },
										{ text: 'GSTIN\n',},
										{ text: 'Local Address\n',},
										{ text: 'Address\n',},
										{ text: 'MOBILE\n',},
										{ text: 'EMAIL\n',},
									]
							}
							],
					],
				
				},
				layout : {
					hLineWidth: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 2 : 1;
					},
					vLineWidth: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 2 : 1;
					},
					hLineColor: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
					},
					vLineColor: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
					},
				}
			},
	
			{
				table: {
					widths: ['42.80%', '*'],
					body: [
						[
							{ text: 'ORDER TO', style: "topHeader" },
							{ text: 'ORDER DETAILS', style: "topHeader" },
						],
						[
						   {
								text:
									[
										{ text: ' ', bold: true },
										{ text: 'Google\n' },
										{ text: ' ', bold: true },
										{ text: '7788996655\n' },
										// { text: ' ', bold: true },
										// { text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
										{ text: ' ', bold: true },
										{ text: '7788996655\n' },
										// { text: ' ', bold: true },
										// { text: '1679905\n' },
										// { text: ' ', bold: true },
										// { text: '23\n' },
									]
							},
						
							{
									text:
										[
											{ text: 'Date: ', bold: true },
											{ text: '12/12/90 \n',  },
											{ text: 'Order: ', bold: true },
											{ text: '12/12/90 \n',  },
											{ text: 'Location: ', bold: true },
											{ text: '12/12/90 \n',  },
											// { text: 'Table: ', bold: true },
											// { text: '12/12/90 \n',  },
										]
								},
							
						],
					]
				}
			},
	
			{
			table: {
                widths: ['5%','40%','5%','10%','10%','15%','15%'],
				body: [
					[
						{ text: 'S.N', style: "productHeader", rowSpan: 2 },
						{ text: 'PARTICULARS', style: "productHeader", rowSpan: 2 },
						// { text: 'HSN/SAC', style: "productHeader", rowSpan: 2 },
						{ text: 'QTY', style: "productHeader", rowSpan: 2 },
						{ text: 'UNIT', style: "productHeader", rowSpan: 2 },
						{ text: 'RATE', style: "productHeader", rowSpan: 2 },
						{ text: 'TAXABLE AMOUNT', style: "productHeader", rowSpan: 2 },
						{ text: 'TOTAL AMOUNT', style: "productHeader", rowSpan: 2 },					
					],
					[
						{ text: 'S.N', style: "productHeader" },
						{ text: 'PARTICULARS', style: "productHeader" },
						// { text: 'HSN/SAC', style: "productHeader" },
						{ text: 'QTY', style: "productHeader" },
						{ text: 'UNIT', style: "productHeader" },
						{ text: 'RATE', style: "productHeader" },
						{ text: 'TAXABLE AMOUNT', style: "productHeader" },
						{ text: 'TOTAL AMOUNT', style: "productHeader" },
					],
				]
			}
		},
					{
				table: {
					widths: ['60%', '*'],
					body: [
						
						[
							{},
							{
								text:
									[
										{ text: 'TAXABLE AMOUNT   :       ', bold: true, style: 'TaxableHeader'},
										{ text: '12122\n', style: 'TaxableHeaderRightAlign' },
										{ text: 'CGST AMOUNT          :       ', bold: true, style: 'TaxableHeader' },
										{ text: '12122\n', style: 'TaxableHeaderRightAlign' },
										{ text: 'SGST AMOUNT          :       ', bold: true, style: 'TaxableHeader' },
										{ text: '12122\n', style: 'TaxableHeaderRightAlign' },
										{ text: 'IGST AMOUNT           :        ', bold: true, style: 'TaxableHeader' },
										{ text: '12122\n', style: 'TaxableHeaderRightAlign' },
										{ text: 'TOTAL AMOUNT        :       ', bold: true, style: 'TaxableHeaderTotal' },
										{ text: '12122\n', style: 'TaxableHeaderTotalRightAlign' }
								]
	
							},
							
						],
					],
				
				
				},
					style:'tab2',
					
	
				
			},
			
				{
				table: {
					widths: ['30%','40%', '30%'],
					body: [
						[
							{
								   text:
									   [
										   { text: 'PAYMENT DETAILS\n' ,style:'transpotationDel'},
										   { text: '' ,style:'invoiceDetails'},
										   
									   ]
							   },
							{
								   text:
									   [
										   { text: 'TERMS AND CONDITIONS\n' ,style:'transpotationDel'},
										   { text: '' ,style:'invoiceDetails'},
										   
									   ]
							   },
						   
						   {
							   text:
								   [	{ text: '' },
									   { text: 'Firm Name  ', bold: true,	style: 'transpotationDel' },
									   { text: '\n\n\n\n' },
									   
									   { text: 'AUTHORITY SIGNATURE', bold: true, style: 'transpotationDel'},
									   { text: '\n' },
								   ]
   
						   },
						   ],
					],
				
				},
				layout : {
						hLineWidth: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 2 : 1;
					},
					vLineWidth: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 2 : 1;
					},
					hLineColor: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
					},
					vLineColor: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
					},
				}
			},
			{
				table: {
					widths: ['*'],
					body: [
						[
							{ text: 'Thank you for giving us your valuable time ! Visit Again', style: 'thankyouMsg' },
						],
					],
				},
			},	
		],
		footer: {
			columns: [
				{ text: 'Powered By ACUIFY', alignment: 'right', color: '#160091' }
			],
			margin: [10, 10]
		},
		styles: {
			header: {
				fontSize: 14,
				bold: true,
				alignment: 'center'
			},
			thankyouMsg: {
				fontSize: 12,
				alignment: 'center',
				bold: true,
				color: '#160091'
			},
			productHeader: {
				fontSize: 11,
				bold: true,
				alignment: 'center',
				color: '#160091',
			},
			transpotationDel : {
                fontSize: 11,
				bold: true,
				alignment: 'center',
				color: '#160091',
			},
			gstHeader: {
				fontSize: 9,
				color: '#160091',
				bold: true,
				alignment: 'center'
			},
			TaxableHeader: {
				fontSize: 12,
				bold: true,		
            },
            TaxableHeaderRightAlign: {
                fontSize: 12,
				bold: true,
				alignment: 'right'
            },
            TaxableHeaderTotal: {
				fontSize: 12,
				bold: true,		
            },
            TaxableHeaderTotalRightAlign: {
                fontSize: 12,
				color: '#160091',
				bold: true,
				alignment: 'right'
            },
			TotalHeader: {
				fontSize: 10,
				bold: true,
				color: '#160091',		
			},
			FirmHeader: {
				fontSize: 12,
				color: '#160091',
				bold: true,
			},
			product: {
				fontSize: 9,
				alignment: 'center',
            },
            product1: {
				fontSize: 10,
				alignment: 'left',
			},
			productRight: {
				fontSize: 10,
				alignment: 'right',
			},
			productTotalLeft: {
				fontSize: 12,
				alignment: 'left',
				bold: true,
				color: '#160091'
			},
			productTotalRight: {
				fontSize: 12,
				alignment: 'right',
				bold: true,
				color: '#160091'
			},
			total: {
				fontSize: 10,
				alignment: 'center',
				bold: true,
			},
			topHeader: {
				color: '#160091',
				fontSize: 13,
				alignment: 'center',
				bold: true,
			},
			invoiceDetails: {
				fontSize: 9,
			}
		}
	}
		//Firm Details 
		pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
		// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[5].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
		// pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
		// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";
	
		//Invoice Details
		// pdfDoc.content[1].table.body[1][1].text[1].text = new Date(metaData.invoiceData.date).toLocaleString() + "\n";
		pdfDoc.content[1].table.body[1][1].text[1].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB') + '  -  ' + new Date(metaData.invoiceData.time).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) + "\n";
		pdfDoc.content[1].table.body[1][1].text[3].text = metaData.invoiceData.orderNumber + "\n";
		pdfDoc.content[1].table.body[1][1].text[5].text = metaData.invoiceData.floorName + '-' +  metaData.invoiceData.tableName + "\n";
	
		//Receipient Details
	
		pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";
	
	
		//Products
		let productList = convertToPDFProducts(metaData.invoiceData.items,true);
		productList.map((item) => {
			pdfDoc.content[2].table.body.push(item);
		});

			//Bank Account Details
			if(metaData.terms.banks.length) {
				metaData.terms.banks.map((bankDetails)=>{
					pdfDoc.content[4].table.body[0][0].text.push({text: bankDetails.bankName + " ( "+ bankDetails.ifsccode + " )\n",style:'invoiceDetails'})
					pdfDoc.content[4].table.body[0][0].text.push({text:"A/C: " + bankDetails.accountnumber + "\n",style:'invoiceDetails'})
					pdfDoc.content[4].table.body[0][0].text.push({text:bankDetails.address + "\n",style:'invoiceDetails'})
				})	
			}
			
				
			//Terms and cond
            pdfDoc.content[4].table.body[0][1].text[1].text = metaData.terms.termsAndConditions;
            
            let productLength =  pdfDoc.content[2].table.body.length-1;
				
			//gst details
			// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
			pdfDoc.content[3].table.body[0][1].text[1].text = pdfDoc.content[2].table.body[productLength][5].text + "\n";
			pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? Number.parseFloat(metaData.gstTotal.CGST_val).toFixed(2) : '0') + "\n";
			pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? Number.parseFloat(metaData.gstTotal.SGST_val).toFixed(2) : '0') + "\n";
			pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? Number.parseFloat(metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
			pdfDoc.content[3].table.body[0][1].text[9].text = pdfDoc.content[2].table.body[productLength][6].text + "\n";
					
			// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
		
			//authority
			pdfDoc.content[4].table.body[0][2].text[1].text =  (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');
			
			if(metaData.terms.printLogo) {
				try {
					let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
					pdfDoc.content[0].table.body[0][0].image = logoData;
					return pdfDoc;
				} catch (error) {
				  console.log(error)
				}
			} else {
				var imgToExport = document.getElementById('pdfimgToExport');
				var canvas = document.createElement('canvas');
				canvas.width = imgToExport.width; 
				canvas.height = imgToExport.height; 
				canvas.getContext('2d').drawImage(imgToExport, 0, 0);
				let base64 = canvas.toDataURL('image/png')
				pdfDoc.content[0].table.body[0][0].image = base64;
			} 
		
	return pdfDoc;
}

export const convertToOrderWithoutGST = async (metaData)=>{
	let pdfDoc =    {
		content: [
			{
				table: {
					widths: ['40%','60%'],
					body: [
						[
							{
								image: 'sampleImage.jpg',
								width: 120,
								height: 80,
								},
  
								{
								text:
									[
										{ text: 'Firm Name\n', style: 'FirmHeader' },
										{ text: 'LocalAddress\n',},
										{ text: 'Address\n',},
										{ text: 'MOBILE\n',},
										{ text: 'EMAIL\n',},
									]
							}
							],
					],
				
				},
				layout : {
					hLineWidth: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 2 : 1;
					},
					vLineWidth: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 2 : 1;
					},
					hLineColor: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
					},
					vLineColor: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
					},
				}
			},
	
			{
				table: {
					widths: ['40%', '*'],
					body: [
						[
							{ text: 'ORDER FROM', style: "topHeader" },
							{ text: 'ORDER DETAILS', style: "topHeader" },
						],
						[
						   {
								text:
									[
										{ text: ' ', bold: true },
										{ text: 'Google\n' },
										{ text: ' ', bold: true },
										// { text: '7788996655\n' },
										// { text: ' ', bold: true },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
										{ text: ' ', bold: true },
										{ text: '7788996655\n' },
										// { text: ' ', bold: true },
										// { text: '1679905\n' },
										// { text: ' ', bold: true },
										// { text: '23\n' },
									]
							},
						
							{
									text:
										[
											{ text: 'Date: ', bold: true },
											{ text: '12/12/90 \n',  },
											{ text: 'Order: ', bold: true },
											{ text: '12/12/90 \n',  },
											{ text: 'Location: ', bold: true },
											{ text: '12/12/90 \n',  },
											// { text: 'Table: ', bold: true },
											// { text: '12/12/90 \n',  },										
										]
								},
							
						],
					]
				}
			},
	
			{
			table: {
                widths: ['7%','34%','9%','15%','15%','20%'],
				body: [
					[
						{ text: 'S.No', style: "productHeader", rowSpan: 2 },
						{ text: 'Product Name', style: "productHeader", rowSpan: 2 },
						// { text: 'HSN code', style: "productHeader", rowSpan: 2 },
						{ text: 'Quantity', style: "productHeader", rowSpan: 2 },
						{ text: 'Units', style: "productHeader", rowSpan: 2 },
						{ text: 'Rate', style: "productHeader", rowSpan: 2 },
						{ text: 'Total Amount', style: "productHeader", rowSpan: 2 },					
					],
					[
						{ text: 'S.No', style: "productHeader" },
						{ text: 'Product Description', style: "productHeader" },
						// { text: 'HSN code', style: "productHeader" },
						{ text: 'Qty', style: "productHeader" },
						{ text: 'Units', style: "productHeader" },
						{ text: 'Rate', style: "productHeader" },
						{ text: 'Total Amount', style: "productHeader" },
					],
				]
			}
		},
					{
				table: {
					widths: ['65.80%', '*'],
					body: [
						
						[
							{},
							{
								text:
									[
										{ text: 'Payable Amount:         ', bold: true, style: 'TotalHeader' },
										{ text: '12122\n', style: 'TotalHeader' }
								]
	
							},
							
						],
					],
				
				
				},
					style:'tab2',
					
	
				
			},
			
			{
				table: {
					widths: ['30%','40%', '30%'],
					body: [
						[
							{
								   text:
									   [
										   { text: 'PAYMENT DETAILS\n' ,style:'transpotationDel'},
										   { text: '' ,style:'invoiceDetails'},
										   
									   ]
							   },
							{
								   text:
									   [
										   { text: 'TERMS AND CONDITIONS\n' ,style:'transpotationDel'},
										   { text: '' ,style:'invoiceDetails'},
										   
									   ]
							   },
						   
						   {
							   text:
								   [	{ text: '' },
									   { text: 'Firm Name  ', bold: true,	alignment: 'center', color: 'primary' },
									   { text: '\n\n\n' },
									   
									   { text: 'AUTHORITY SIGNATURE', bold: true, alignment: 'center', color: 'primary'},
									   { text: '\n' },
								   ]
   
						   },
						   ],
					],
				
				},
				layout : {
					hLineWidth: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 1 : 1;
					},
					vLineWidth: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 1 : 1;
					},
					hLineColor: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
					},
					vLineColor: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
					},
				}
			},
			{
				table: {
					widths: ['*'],
					body: [
						[
							{ text: 'Thank you for giving us your valuable time ! Visit Again', style: 'thankyouMsg' },
						],
					],
				},
			},
		],
		footer: {
			columns: [
				{ text: 'Powered By ACUIFY', alignment: 'right', color: '#160091' }
			],
			margin: [10, 10]
		},
		styles: {
			header: {
				fontSize: 14,
				bold: true,
				alignment: 'center'
			},
			productHeader: {
				fontSize: 11,
				bold: true,
				alignment: 'center',
				color: '#160091',
			},
			transpotationDel : {
				bold: true,
				alignment: 'center',
				color: '#160091',
			},
			gstHeader: {
				fontSize: 9,
				color: '#160091',
				bold: true,
				alignment: 'center'
			},
			TaxableHeader: {
				fontSize: 10,
				bold: true,		
			},
			TotalHeader: {
				fontSize: 12,
				bold: true,
				color: '#160091',		
			},
			FirmHeader: {
				fontSize: 16,
				color: '#160091',
				bold: true,
			},
			thankyouMsg: {
				fontSize: 12,
				alignment: 'center',
				bold: true,
				color: '#160091'
			},
			product: {
				fontSize: 9,
				alignment: 'center',
			},
			product1: {
				fontSize: 10,
				alignment: 'left',
			},
			productRight: {
				fontSize: 10,
				alignment: 'right',
			},
			productTotalRight: {
				fontSize: 12,
				alignment: 'right',
				bold: true,
				color: '#160091'
			},
			productTotalLeft: {
				fontSize: 12,
				alignment: 'left',
				bold: true,
				color: '#160091'
			},
			total: {
				fontSize: 10,
				alignment: 'center',
				bold: true
			},
			topHeader: {
				color: '#160091',
				fontSize: 13,
				alignment: 'center',
				bold: true,
			},
			invoiceDetails: {
				fontSize: 9,
			}
		}
	}
		//Firm Details 
		pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
		// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
		// pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";

		// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";
	
		//Invoice Details
		pdfDoc.content[1].table.body[1][1].text[1].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB') + '  -  ' + new Date(metaData.invoiceData.time).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) + "\n";
		pdfDoc.content[1].table.body[1][1].text[3].text = metaData.invoiceData.orderNumber + "\n";
		pdfDoc.content[1].table.body[1][1].text[5].text = metaData.invoiceData.floorName + '-' + metaData.invoiceData.tableName + "\n";
		//Receipient Details
	
		pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";
	
	
		//Products
		let productList = null;
		if(metaData.call) {
			productList = convertToPDFProducts(metaData.invoiceData.items.filter(i=> i.call == metaData.call),false);
		} else {
			productList = convertToPDFProducts(metaData.invoiceData.items,false);
		}
		productList.map((item) => {
			pdfDoc.content[2].table.body.push(item);
		});

			//Bank Account Details
			if(metaData.terms.banks.length) {
				metaData.terms.banks.map((bankDetails)=>{
					pdfDoc.content[4].table.body[0][0].text.push({text: bankDetails.bankName + " ( "+ bankDetails.ifsccode + " )\n",style:'invoiceDetails'})
					pdfDoc.content[4].table.body[0][0].text.push({text:"A/C: " + bankDetails.accountnumber + "\n",style:'invoiceDetails'})
					pdfDoc.content[4].table.body[0][0].text.push({text:bankDetails.address + "\n",style:'invoiceDetails'})
				})	
			}
			
				
			//Terms and cond
            pdfDoc.content[4].table.body[0][1].text[1].text = metaData.terms.termsAndConditions;
            
            let productLength =  pdfDoc.content[2].table.body.length-1;
				
			//gst details
			pdfDoc.content[3].table.body[0][1].text[1].text = pdfDoc.content[2].table.body[productLength][5].text + "\n";
					
			// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
		
			//authority
			pdfDoc.content[4].table.body[0][2].text[1].text =  (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');
			
			if(metaData.terms.printLogo) {
				try {
					let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
					pdfDoc.content[0].table.body[0][0].image = logoData;
					return pdfDoc;
				} catch (error) {
				  console.log(error)
				}
			} else {
				var imgToExport = document.getElementById('pdfimgToExport');
				var canvas = document.createElement('canvas');
				canvas.width = imgToExport.width; 
				canvas.height = imgToExport.height; 
				canvas.getContext('2d').drawImage(imgToExport, 0, 0);
				let base64 = canvas.toDataURL('image/png')
				pdfDoc.content[0].table.body[0][0].image = base64;
			} 
		
	return pdfDoc;
}



// WEBPACK FOOTER //
// ./src/utils/orderPdf.js